import React, { Component } from 'react'
import AOS from 'aos';
import Button from "../../components/Button"

import videoIcon from "../../assets/images/video-icon.svg"
import bookIcon from "../../assets/images/book-icon.svg"
import mentorshipIcon from "../../assets/images/mentorship-icon.svg"
import setupIcon from "../../assets/images/setup-icon.svg"
import dashboardmockup from "../../assets/images/dashboardmockup.png"
import { Link } from "react-router-dom"


class FinancialFreedom extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {
        return (
            <>
                <div className="financial-freedom">
                    <div className="discussion-image">
                        <div className="discussion-text">
                            <h1 className="bold">DO YOU DESIRE <br /> FINANCIAL FREEDOM?</h1>
                            <h4 className="mt-10"><Link to="/academy"> <span className="underline">Sign up</span> </Link> and explore the different ways you can start generating and <br /> diversifying forex trading success.</h4>
                        </div>
                    </div>
                    <div className="resources">
                        <div className="grey-box" data-aos="fade-up" data-aos-delay="60" data-aos-duration="1500">
                            <img src={videoIcon} alt="video icon" />
                            <h4 className="mt-45">VIDEO RESOURCES</h4>
                        </div>
                        <div className="grey-box" data-aos="fade-up" data-aos-delay="70" data-aos-duration="1600">
                            <img src={bookIcon} alt="book icon" />
                            <h4 className="mt-25">TRADING <br /> BOOKS & MATERIALS</h4>
                        </div>
                        <div className="grey-box" data-aos="fade-up" data-aos-delay="80" data-aos-duration="1700">
                            <img src={mentorshipIcon} alt="mentorship-icon" />
                            <h4 className="mt-25">LIFETIME <br /> MENTORSHIP</h4>
                        </div>
                        <div className="grey-box" data-aos="fade-up" data-aos-delay="90" data-aos-duration="1800">
                            <img src={setupIcon} alt="setup icon" />
                            <h4 className="mt-23">WEEKLY <br /> TRADE SETUPS</h4>
                        </div>
                    </div>
                </div>
                <div className="dashboardmock">
                    <div className="dashboardmock-large">
                        <div className="dashboardmock-bg">
                            <div>
                                <img src={dashboardmockup} />
                            </div>
                            <div>
                                <h2>Trading the forex market isn’t difficult or complex if you get the right resources & mentorship.</h2>
                                <div data-aos="zoom-in-left" data-aos-delay="100" data-aos-duration="2000">
                                    <Button className="dashboardmock-btn">
                                        <Link to="/academy">
                                            <p>Register now</p>
                                        </Link>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default FinancialFreedom;